var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMakeGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2317_5885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.89986 7.25C6.89986 6.97386 7.12371 6.75 7.39986 6.75H14.3989C14.675 6.75 14.8989 6.97386 14.8989 7.25V8.75C14.8989 9.02614 14.675 9.25 14.3989 9.25H7.39986C7.12371 9.25 6.89986 9.02614 6.89986 8.75V7.25Z",
    stroke: "#CBD0E0",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.89986 12.25C6.89986 11.9739 7.12371 11.75 7.39986 11.75H14.3989C14.675 11.75 14.8989 11.9739 14.8989 12.25V13.75C14.8989 14.0261 14.675 14.25 14.3989 14.25H7.39986C7.12371 14.25 6.89986 14.0261 6.89986 13.75V12.25Z",
    stroke: "#CBD0E0",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.10449 2.25C2.10449 1.97386 2.32835 1.75 2.60449 1.75H9.60449C9.88063 1.75 10.1045 1.97386 10.1045 2.25V3.75C10.1045 4.02614 9.88063 4.25 9.60449 4.25H2.60449C2.32835 4.25 2.10449 4.02614 2.10449 3.75V2.25Z",
    stroke: "#CBD0E0",
    strokeWidth: 1.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2317_5885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeGroup);
export default __webpack_public_path__ + "static/media/makeGroup.0f3066e3e189a7a47b02a05b1dcf08fd.svg";
export { ForwardRef as ReactComponent };